const MDX_EXTENSION_PATTERN = /\.mdx$/;
const PNG_EXTENSION = ".png";
const OG_DIRECTORY = "og";

export function getDocPageUrlPath(pagePath: string): string {
  return pagePath.replace(/^\/+/, "").replace(MDX_EXTENSION_PATTERN, "");
}

export function getDocOgImageRelativePath(pagePath: string): string {
  return `${OG_DIRECTORY}/${getDocPageUrlPath(pagePath)}${PNG_EXTENSION}`;
}
